import React from 'react';
import loadable from 'react-loadable';

import LoadingPage from 'components/common/LoadingPage';

export default loadable({
  loader: () => import(/* webpackChunkName: "account-setup" */ './Main'),
  loading: () => <LoadingPage />,
});



// WEBPACK FOOTER //
// ./src/components/AccountSetup/Lazy.js